<template>
    <div class="w-full">
        <div
            :class="tabClasses"
            class="grid grid-flow-col justify-stretch mb-6"
        >
            <NuxtLink
                v-for="tab in tabs"
                :key="tab.id"
                :class="{
                    'border-b-2 border-black text-black!': !!tab.selected,
                    'border-b-[1.5px] border-gray-50': !tab.selected,
                    'font-bold': !!tab.selected && tabsBold,
                    'text-left': tabsLeft,
                    'text-center': !tabsLeft,
                }"
                :to="tab.to"
                class="pb-1 px-1 md:px-4 text-gray-400 hover:border-black hover:text-black hover:border-b-2 transition-colors uppercase cursor-pointer style-h6"
                @click="emit('changeTab', { tab: tab.id })"
            >
                <span class="hidden md:inline">{{ tab.title }}</span>
                <span class="md:hidden">{{ tab.title_mobile || tab.title }}</span>
            </NuxtLink>
        </div>
        <div>
            <div :class="{ 'max-w-md mx-auto': limitContentWidth, 'w-full': !limitContentWidth }">
                <slot />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { Tab } from "~/types";

withDefaults(
    defineProps<{
        tabs: Tab[];
        tabsBold?: boolean;
        tabsLeft?: boolean;
        tabClasses?: string;
        limitContentWidth?: boolean;
    }>(),
    {
        tabsBold: true,
        tabsLeft: false,
        tabClasses: "",
        limitContentWidth: true,
    },
);

const emit = defineEmits(["changeTab"]);
</script>
